import { useMemo as r } from "react";
import { FirstMessagePositioning as n } from "./types.js";
const i = ({ childrenArray: e, visibleItem: t }) => t ? e.findIndex((s) => s.key === t.key) : -1, o = ({ childrenArray: e }) => e.length - 1, l = {
  scrollFollowOffsetPx: 30,
  scrollLoadHistoryOffsetPx: 100,
  scrollLoadHistoryWorker: async () => {
  },
  estimateSizePx: 100,
  loader: null,
  overscan: 3,
  paddingStart: 100,
  paddingStartFirstMessage: 0,
  paddingEnd: 0,
  appendScrollTargetIndex: o,
  scrollAlignment: "end",
  getScrollButton: null,
  scrollToLastOnAppend: !1,
  firstMessagePosition: n.end
}, c = (e) => r(() => ({
  ...l,
  ...e
}), [e]);
export {
  l as AssistantChatScrollReversedPropDefaults,
  o as defaultAppendTargetIndex,
  i as defaultPrependTargetIndex,
  c as useAssistantChatScrollReversedProps
};
